import axiosInstance from '@/helper/http';

const API_BASE = '/api/v1';

export const storeUsersService = {
  /**
   * Invite a user to a store by phone or email
   * @param {Object} payload - Invitation payload
   * @param {number} payload.store_id - Store ID
   * @param {string} payload.username - Username for the invitation
   * @param {string} [payload.phone_number] - Phone number (optional, if inviting by phone)
   * @param {string} [payload.email] - Email address (optional, if inviting by email)
   * @param {Array} payload.permissions - List of permission names
   * @returns {Promise}
   */
  inviteUser(payload) {
    return axiosInstance.post(
      `${API_BASE}/store-permissions/assign`,
      payload
    );
  },

  /**
   * Get pending invitations for a store
   * @param {number} storeId - Store ID
   * @returns {Promise}
   */
  getPendingInvitations(storeId) {
    return axiosInstance.get(
      `${API_BASE}/store-permissions/pending-invitations`,
      {
        params: { store_id: storeId },
      }
    );
  },

  /**
   * Revoke an invitation
   * @param {number} invitationId - Invitation ID
   * @returns {Promise}
   */
  revokeInvitation(invitationId) {
    return axiosInstance.delete(
      `${API_BASE}/store-permissions/invitations/${invitationId}`
    );
  },

  /**
   * Get all store users
   * @param {number} storeId - Store ID
   * @returns {Promise}
   */
  getStoreUsers(storeId) {
    return axiosInstance.get(
      `${API_BASE}/store-permissions/users`,
      {
        params: { store_id: storeId },
      }
    );
  },

  /**
   * Update user permissions in a store
   * @param {Object} payload - Update payload
   * @param {number} payload.user_store_permission_id - Permission ID
   * @param {Array} payload.permissions - New permissions
   * @returns {Promise}
   */
  updateUserPermissions(payload) {
    return axiosInstance.put(
      `${API_BASE}/store-permissions/user-permissions`,
      payload
    );
  },

  /**
   * Remove user from store
   * @param {number} permissionId - User store permission ID
   * @returns {Promise}
   */
  removeUserFromStore(permissionId) {
    return axiosInstance.delete(
      `${API_BASE}/store-permissions/${permissionId}`
    );
  },
};

export default storeUsersService;
